import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { FlowAuthenticationdGuardService, FlowTenantGuardService } from './services';
import { AuthenticatedGuard } from './services/authenticated-guard';

export const WorkflowRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/organization/workflow-organization.module').then(m => m.WorkflowOrganizationModule), canActivate: [AuthenticatedGuard]
  },
  {
		path: 'login',
    loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginModule),
    canActivate: [AuthenticatedGuard]
	},
  {
		path: 'register',
    loadChildren: () => import('./pages/auth/register-company/register.module').then(m => m.RegisterModule),
    canActivate: [AuthenticatedGuard]
  },
  {
    path: ':tenant/register-user',
    loadChildren: () => import('./pages/auth/register-user/register-user.module').then(m => m.RegisterUserModule),
  },
  {
	path: ':tenant/activate-company-account',
    loadChildren: () => import('./pages/auth/activate-company-account/activate-company-account.module').then(m => m.ActivateCompanyAccountModule),
  },
  {
		path: 'terms-conditions',
    loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule),
  },
  {
		path: 'forgot-password',
    loadChildren: () => import('./pages/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },
  {
		path: 'reset-password',
    loadChildren: () => import('./pages/auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
  },
  {
		path:'not-found',
		//component: TenantNotFoundComponent
    loadChildren: () => import('./pages/errors/error-404/error-404.module').then(m => m.Error404Module)

	},
  {
		path:'join',
		loadChildren: () => import('./pages/JoinTenant/join-tenant.module').then(m => m.JoinTenantModule),
	},
  // {
	// 	path: ':tenant/register',
  //   canActivate: [FlowTenantGuardService],		
  //   loadChildren: () => import('./pages/auth/register-user/register-user.module').then(m => m.RegisterUserModule),
  // },

  {
		path: ':tenant',
    canActivate: [FlowTenantGuardService],
		component:CustomLayoutComponent,
    children:[
      // {
      //   path: 'register',       
      //   loadChildren: () => import('./pages/auth/register-user/register-user.module').then(m => m.RegisterUserModule),
      //   //canActivate: [RemoteDatabaseGuardService],
      // },
      {
        path: '',       
        loadChildren: () => import('./pages/administration/administration.module').then(m => m.WorkflowAdministrationModule),
        canActivate:[FlowAuthenticationdGuardService]
        //canActivate: [RemoteDatabaseGuardService],
      },      
      {
        path: 'remoteconnect',       
        loadChildren: () => import('./pages/auth/remote-connect/remote-connect.module').then(m => m.RemoteConnectModule),
        canActivate:[FlowAuthenticationdGuardService]
      },
      {
        path: 'favorites',       
        loadChildren: () => import('./pages/favorites/favorites.module').then(m => m.WorkflowFavoritesModule),
        canActivate:[FlowAuthenticationdGuardService]        
        //canActivate: [FlowAuthenticationdGuardService],
      },
      {
        path: 'administration',      
        loadChildren: () => import('./pages/administration/administration.module').then(m => m.WorkflowAdministrationModule),
        canActivate: [FlowAuthenticationdGuardService],
        //canActivate: [RemoteDatabaseGuardService]
      },
      {
        path: 'configuration',
        loadChildren: () => import('./pages/configuration/configuration.module').then(m => m.WorkflowConfigurationModule),
        canActivate: [FlowAuthenticationdGuardService],
      },
 
       {
        path: 'settings',
        loadChildren: () => import('./pages/Settings/settings.module').then(m => m.SettingsModule),
        canActivate: [FlowAuthenticationdGuardService],
      },
      {
        path:'wizard',
        loadChildren: () => import('./Components/WorkflowWizard2/workflow-wizard.module').then(m => m.WorkflowWizard2Module),
      }
    ]
		//canActivate: [FlowAuthenticationdGuardService],
	},  
  // {
	// 	path: '',
	// 	loadChildren: () => import('./pages/organization/workflow-organization.module').then(m => m.WorkflowOrganizationModule)
	// 	//canActivate: [FlowAuthenticationdGuardService],
	// },
  // {
	// 	path:'join',
	// 	component: JoinTenantComponent
	// },
	// {
	// 	path: ':tenant',
	// 	canActivate: [FlowAuthenticationdGuardService, FlowTenantGuardService],
	// 	loadChildren: () => import('./WorkflowManagement/workflow-management.module').then(m => m.WorkflowModule)
	// },
  {
    path: '**',
    loadChildren: () => import('./pages/errors/error-404/error-404.module').then(m => m.Error404Module)
  }
  ,
];

@NgModule({
  imports: [RouterModule.forRoot(WorkflowRoutes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
